module.exports = __webpack_public_path__ + "static/media/p15.421db536.png";